import { render } from "./SidebarSimpleLink.vue?vue&type=template&id=6120c798&scoped=true"
import script from "./SidebarSimpleLink.vue?vue&type=script&lang=js"
export * from "./SidebarSimpleLink.vue?vue&type=script&lang=js"

import "./SidebarSimpleLink.vue?vue&type=style&index=0&id=6120c798&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6120c798"]])

export default __exports__